<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-实名认证-修改
    -->
    <el-dialog
    title="修改实名认证"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改认证</div>

      <!-- 姓名 -->
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入姓名" class="max-w460"></el-input>
      </el-form-item>

      <!-- 手机号 -->
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号" class="max-w460"></el-input>
      </el-form-item>

      <!-- 银行卡号 -->
      <el-form-item label="银行卡号" prop="bank_card_number">
        <el-input v-model="form.bank_card_number" placeholder="请输入银行卡号" class="max-w460"></el-input>
      </el-form-item>

      <!-- 开户行 -->
      <el-form-item label="开户行" prop="bank">
        <el-input v-model="form.bank" placeholder="请输入开户行" class="max-w460"></el-input>
      </el-form-item>

      <!-- 银行卡正面图片 -->
      <el-form-item label="银行卡正面" prop="idCardFront">
        <div class="draggable-list">
          <div class="item" v-if="form.idCardFront && form.idCardFront.length > 0">
            <img v-img-url="form.idCardFront[0].file_path" alt="银行卡正面"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('idCardFront')">
              <i class="el-icon-close"></i>
            </a>
          </div>
          <div class="item img-select" @click="openProductUpload('idCardFront')" v-else>
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <!-- 银行卡背面图片 -->
      <el-form-item label="银行卡背面" prop="idCardBack">
        <div class="draggable-list">
          <div class="item" v-if="form.idCardBack && form.idCardBack.length > 0">
            <img v-img-url="form.idCardBack[0].file_path" alt="银行卡背面"/>
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg('idCardBack')">
              <i class="el-icon-close"></i>
            </a>
          </div>
          <div class="item img-select" @click="openProductUpload('idCardBack')" v-else>
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      <!-- 排序 -->
      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!--图片上传组件-->
    <Upload v-if="isProductUpload" :config="{ total: 1 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
  </div>

</el-dialog>
  
</template>

<script>
import CertificationxApi from '@/api/certificationx.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
     Upload: Upload
  },
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };
    
    // 银行卡号验证规则
    const validateBankCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入银行卡号'));
      } else if (!/^\d{16,19}$/.test(value)) {
        callback(new Error('银行卡号格式不正确'));
      } else {
        callback();
      }
    };

    return {
      /*是否上传图片*/
      isProductUpload: false,
      currentUploadField: '', // 当前上传的字段
      
      /*form表单数据*/
      form: {
        name: '',
        phone: '',
        bank_card_number: '',
        bank: '',
        idCardFront: [],
        idCardBack: [],
        sort: 50
      },
      
      loading: false,
      
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        bank_card_number: [{ required: true, validator: validateBankCard, trigger: 'blur' }],
        bank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        idCardFront: [{ 
          required: true, 
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error('请上传银行卡正面图片'));
            } else {
              callback();
            }
          }, 
          trigger: 'change' 
        }],
        idCardBack: [{ 
          required: true, 
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error('请上传银行卡背面图片'));
            } else {
              callback();
            }
          }, 
          trigger: 'change' 
        }]
      },
      
      dialogVisible: false
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    if (this.certificationx_id) {
      this.getDetail();
    }
  },
  props: ["open_add", "certificationx_id"],
  watch: {
    open_add(newVal) {
      this.dialogVisible = newVal;
      if (newVal && this.certificationx_id) {
        this.getDetail();
      }
    }
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
      // 重置表单
      this.form = {
        name: '',
        phone: '',
        bank_card_number: '',
        bank: '',
        idCardFront: [],
        idCardBack: [],
        sort: 50
      };
    },
    
    cancelFunc() {
      this.dialogFormVisible("error")
    },
    
    getDetail() {
      let self = this;
      CertificationxApi.detail({certificationx_id: self.certificationx_id}, true)
        .then(res => {
          self.form = res.data;
          // 确保图片字段是数组格式
          if (self.form.idCardFront && !Array.isArray(self.form.idCardFront)) {
            self.form.idCardFront = self.form.idCardFront ? [{ file_path: self.form.idCardFront }] : [];
          }
          if (self.form.idCardBack && !Array.isArray(self.form.idCardBack)) {
            self.form.idCardBack = self.form.idCardBack ? [{ file_path: self.form.idCardBack }] : [];
          }
          self.loading = false;
        })
        .catch(error => {
          console.error('获取详情失败:', error);
        });
    },
    
    onSubmit() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form)); // 深拷贝表单数据
      
      // 验证图片是否上传
      if (!form.idCardFront || form.idCardFront.length === 0) {
        self.$message({
          message: "请上传银行卡正面图片",
          type: 'error'
        });
        return;
      }
      
      if (!form.idCardBack || form.idCardBack.length === 0) {
        self.$message({
          message: "请上传银行卡背面图片",
          type: 'error'
        });
        return;
      }
      
      form.certificationx_id = self.certificationx_id;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CertificationxApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("success")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*打开上传图片*/
    openProductUpload(field) {
      this.isProductUpload = true;
      this.currentUploadField = field;
    },

    /*上传图片*/
    returnProductImgsFunc(e) {
      if (e && e.length > 0) {
        // 验证图片格式
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let data_array = e[0].file_path.split(".");
        let ext = data_array[data_array.length - 1];
        let prevent = imgExpt.some(item => item === ext);
        
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        
        // 设置对应字段的图片路径（替换原有图片）
        this.$set(this.form, this.currentUploadField, [e[0]]);
      }
      this.isProductUpload = false;
    },

    /*删除图片*/
    deleteImg(field) {
      this.$set(this.form, field, []);
    }
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.max-w460 {
  max-width: 460px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/certificationx/index/part/edit.vue